export default __webpack_public_path__ + "static/media/mangchi.a6eb3698.png";